import styled from 'styled-components';

export default styled.div`
    margin: 28px 0 12px 0;
`;
